import { useState, useEffect } from "react";
import { Nav } from "../../layouts/Nav/Nav";
import { Footer } from "../../layouts/Footer/Footer";
import { Button } from "../../ui/Button";
import { PopUpForm } from "../../components/PopUpForm/PopUpForm";
import "../../styles/DataDeletion.scss";

export function DataDeletion() {
  const [popupType, setPopupType] = useState(null);

  const openForm = (type) => {
    setPopupType(type);
    document.body.classList.add("no-scroll");
  };

  const closeForm = () => {
    setPopupType(null);
    document.body.classList.remove("no-scroll");
  };

  useEffect(() => {
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <div className="data-container">
      <Nav />

      <div className="reguest-data">
        <h1 className="data-title">Data Deletion</h1>
        <div className="content-box">
          <h2>Request Data Deletion</h2>
          <p>
            If you wish to delete all data associated to you from Storiya app,
            you can do so here. Contact us and we'll process your request as
            soon as possible
          </p>
          <Button
            className="data-button"
            name="DATA DELETION REQUEST"
            onClick={() => openForm("data")}
          />
        </div>

        <div className="content-box">
          <h2>Request Account Deletion</h2>
          <p>
            If you wish to delete your account and all associated data from Storiya app,
            you can do so here. Contact us and we'll process your request as
            soon as possible
          </p>
          <Button
            className="data-button"
            name="ACCOUNT DELETION REQUEST"
            onClick={() => openForm("account")}
          />
        </div>

        {popupType === "data" && (
          <PopUpForm
            title="Data Deletion Request"
            dbPath="data_deletion_requests"
            onClose={closeForm}
          />
        )}

        {popupType === "account" && (
          <PopUpForm
            title="Account Deletion Request"
            dbPath="account_deletion_requests"
            onClose={closeForm}
          />
        )}
      </div>

      <Footer />
    </div>
  );
}
